<template>
  <div
    v-if="settings"
    class="bg-primary-dark text-white"
  >
    <footer
      class="flex flex-wrap items-center px-6 py-12 mx-auto text-gray-200 max-w-screen-2xl md:px-8 lg:px-6 xl:px-32 md:py-24 gap-x-12 lg:gap-x-24"
    >
      <div class="flex flex-col flex-1  text-white text-xl lg:text-3x">
        <div
          class="flex flex-wrap justify-end gap-6 lg:gap-x-12 pr-[2.75rem]   text-orange md:pr-[3rem] lg:pr-[4.25rem] mt-3 lg:mt-6"
        >
          <div
            v-for="{ email, name, role } in settings.contact"
            :key="email"
            class="w-full lg:w-auto"
          >
            <NuxtLink
              :to="`mailto:${email}`"
              class="flex flex-col group"
            >
              <Icon
                name="ri:mail-line"
                class="text-primary group-hover:text-zinc-950"
              />
              <span class="block font-title font-bold">{{ name }}</span>
              <span class="block text-sm leading-4 text-white/90">{{ role }}</span>
              <span class="block text-xs pt-3 border-b-2 border-transparent group-hover:border-zinc-950 self-start">{{ email }}</span>
            </NuxtLink>
          </div>
          <!-- {{ settings.contact }} -->
        </div>
      </div>
    </footer>
    <nav
      class="flex flex-wrap items-center justify-center px-6 py-12 font-light text-center gap-x-6 gap-y-2 md:gap-8 lg:gap-10 xl:gap-16"
    >
      <template
        v-for="link in navigation"
        :key="link.to"
      >
        <NuxtLink
          :to="getPage({ to: link.to })"
          class="text-white hover:text-white/90"
        >{{ link.text }}</NuxtLink>
      </template>
      <div class="flex flex-wrap gap-6 text-xl lg:text-2xl items-center">
        <NuxtLink
          v-if="settings.facebook"
          :href="settings.facebook"
          class="pt-1"
        ><Icon name="ri:facebook-line" /></NuxtLink>
        <NuxtLink
          v-if="settings.twitter"
          :href="settings.twitter"
          class="pt-1"
        ><Icon name="ri:twitter-x-line" /></NuxtLink>

        <NuxtLink
          v-if="settings.linkedIn"
          :href="settings.linkedIn"
          class="pt-1"
        ><Icon name="ri:linkedin-line" /></NuxtLink>

        <NuxtLink
          v-if="settings.bluesky"
          :href="settings.bluesky"
          class="pt-1"
        ><Icon name="ri:bluesky-line" /></NuxtLink>
      </div>
    </nav>
    <div
      class="flex flex-wrap items-center justify-center px-6 py-12 font-light text-center text-white gap-x-6 gap-y-2 md:gap-8 lg:gap-10 xl:gap-16"
    >
      <MCT />
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{ navigation?: { text: string, to: string }[] }>()
const settings = useState<Settings>('settings')
</script>
